import React, { useEffect, useState } from "react";
// import { loginBack } from "helper/constant";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import AuthActions from "redux/auth/actions";
import enhancer from "./enhancer/LoginFormEnhancer";
import { checkApi, loginApi } from "services/authServices";
import NavigationActions from "redux/navigation/actions";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Loader from "components/Loader";
import svgLogo from "../../../assets/images/logo.svg";
import SideImage from "./SideImage";

const { login, setUser, logout } = AuthActions;

const {
  success,
  error,
  toggleOneTimeModal,
  fetching,
  toggleSubscriptionLoader
} = NavigationActions;

const Login = props => {
  const [togglePassword, setTogglePassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLogin = async e => {
    e.preventDefault();
    let { values, handleSubmit, isValid } = props;
    handleSubmit();

    // console.log("user", user);
    // console.log("props in login ", props);

    // if (values.email !== "" && values.password !== "") {
    //   // console.log("Here is your form value", values);

    //   const data = {
    //     token: "DEMOJWTTOKEN"
    //   };
    //   // using this method you can store token in redux
    //   props.login(data);
    //   props.history.push("/dashboard");
    // }
    // handleSubmit();

    if (isValid) {
      fetching();
      // console.log("values", values);
      setLoading(true);
      await loginApi(values).then(data => {
        console.log(data.data, "login data");
        if (data.success) {
          success(data.message);
          props.login(data.data);
          let userData = data.data;
          props.setUser(userData);
          props.history.push("/admin/dashboard");
          // console.log(userData, "userData");
          setLoading(false);
        } else {
          error(data.message);
          setLoading(false);
        }
      });
    }
  };

  const {
    values,
    handleChange,
    handleBlur,
    errors,
    touched,
    submitCount,
    // isValid,
    token
    // user
  } = props;

  // const loginContainer = {
  //   backgroundImage: `url(${loginBack})`,
  //   backgroundPosition: "center center",
  //   backgroundSize: "cover",
  //   position: "fixed",
  //   overflow: "auto",
  //   top: 0,
  //   bottom: 0
  // };

  const checkLogin = async () => {
    fetching();
    await checkApi(token).then(data => {
      // console.log("user", user);

      if (data.success) {
        console.log("check superadmin");
        console.log("data check 123", data.data);
        // check(data.data);
        // toggleSubscriptionLoader(false);
        if (data.data.is_superadmin) {
          success();
          props.history.push("/admin/dashboard");
        } else {
          logout(token);
        }
      } else {
        error();
      }
    });
  };

  useEffect(() => {
    token && token !== null && token !== "null" && checkLogin();
    // eslint-disable-next-line
  }, []);
  const Error = props => {
    const field1 = props.field;
    if ((errors[field1] && touched[field1]) || submitCount > 0) {
      return (
        <span className={props.class ? props.class : "error-msg"}>
          {errors[field1]}
        </span>
      );
    } else {
      return <span />;
    }
  };

  return (
    <div className="login-row">
      <div className="login-box">
        <div className="form-container login-form ">
          <div className="logo">
            <img src={svgLogo} alt="" />
          </div>
          {/* <div className="login-icon">
          <img src={iconDemo} alt="icon" height="100px" />
        </div> */}
          <div className="login-title">Sign in to your account</div>
          <form onSubmit={handleLogin}>
            <div className="form-group">
              {/* <label>Email</label> */}
              <input
                type="email"
                className="form-control react-form-input"
                id="email"
                onChange={handleChange}
                value={values.email}
                onBlur={handleBlur}
                placeholder="Enter email"
              />
              <Error field="email" />
            </div>

            <div className="form-group">
              {/* <label>Password</label> */}
              {/* <input
              type="password"
              className="form-control react-form-input"
              id="password"
              value={values.password}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Password"
            /> */}
              <div className="input-group show-hide-password">
                <input
                  type={togglePassword ? "text" : "password"}
                  className="form-control react-form-input"
                  id="password"
                  onChange={handleChange}
                  value={values.password}
                  onBlur={handleBlur}
                  placeholder="Enter password"
                />
                <div className="input-group-append">
                  {togglePassword ? (
                    <VisibilityOff onClick={() => setTogglePassword(false)} />
                  ) : (
                    <Visibility
                      onClick={() => {
                        setTogglePassword(true);
                        // console.log("clicked");
                      }}
                    />
                  )}
                </div>
              </div>
              <Error field="password" />
            </div>

            {/* <div className="form-check text-center mtb-16">
            <input
              type="checkbox"
              className="form-check-input"
              id="exampleCheck1"
            />
            <label className="form-check-label" htmlFor="exampleCheck1">
              Remember me
            </label>
          </div> */}
            {/* {console.log(isValid, "isValid", values)} */}

            <button
              type="submit"
              className="btn form-button siteenterbutton mt-3"
            >
              Login
            </button>
            <div className="d-flex justify-content-between mt-2">
              <div
                className="text-right link-label"
                onClick={() => props.history.push("/admin/forgotPassword")}
              >
                Forgot Password ?
              </div>
            </div>
          </form>
        </div>
        {loading && <Loader />}
      </div>
      <SideImage />
    </div>
  );
};

const mapStateToProps = state => {
  // console.log(state);
  return {
    token: state.auth.accessToken,
    user: state.auth.user,
    isUser: state.auth.isUser,
    isSuperAdmin: state.auth.isSuperAdmin

    // isFetching: state.navigation.isFetching
  };
};

export default compose(
  withRouter,
  enhancer,
  connect(mapStateToProps, {
    // check,
    login,
    logout,
    success,
    error,
    toggleOneTimeModal,
    toggleSubscriptionLoader,
    fetching,
    setUser
  })
)(Login);
